import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Meta } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { Editor } from "ngx-editor";
import { CategoriesModel } from "src/models/categories.model";
import { CommuneModel } from "src/models/commune.model";
import { Company } from "src/models/company.model";
import { CompanyTypeModel } from "src/models/company_type.model";
import { CountriesModel } from "src/models/countries.model";
import { Prefecture } from "src/models/prefecture";
import { Role } from "src/models/role.model";
import { CategoriesService } from "src/services/categories/categories.service";
import { CommmuneService } from "src/services/commune/commmune.service";
import { CompanyService } from "src/services/company/company.service";
import { CompanyTypService } from "src/services/company_type/company-typ.service";
import { CountriesService } from "src/services/countries/countries.service";
import { PrefectureService } from "src/services/prefecture/prefecture.service";
import { RegionService } from "src/services/region/region.service";
import { UserService } from "src/services/user/user.service";
import Swal from "sweetalert2";

import { MenuItem } from "primeng/api";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-create-account",
  templateUrl: "./create-account.component.html",
  styleUrls: ["./create-account.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService],
})
export class CreateAccountComponent implements OnInit, OnDestroy {
  form: FormGroup = new FormGroup({});
  type: string;
  roles: Array<Role>;
  companyTypes: Array<CompanyTypeModel>;
  sectors: Array<Company>;
  categories: Array<CategoriesModel>;
  prefectures: Array<Prefecture>;
  communes: Array<CommuneModel>;
  countries: Array<CountriesModel>;

  search: string;

  loading: boolean;

  editor: Editor;
  html = "";

  stateOptions: any[];

  items: MenuItem[];

  activeIndex: number = 0;

  constructor(
    private fb: FormBuilder,
    private companyTypeService: CompanyTypService,
    private companyService: CompanyService,
    public categoryService: CategoriesService,
    public regionService: RegionService,
    private prefectureService: PrefectureService,
    private communeService: CommmuneService,
    public countryService: CountriesService,
    private meta: Meta,
    private router: Router,
    private messageService: MessageService
  ) {}

  initForm() {
    this.stateOptions = [
      { label: "OUI", value: "OUI" },
      { label: "NON", value: "NON" },
    ];

    // Balises meta pour le référencement
    this.meta.updateTag({
      name: "description",
      content:
        "Inscrivez votre PME sur la plateforme BSTP Guinée pour accéder à des services financiers adaptés, des formations et un accompagnement personnalisé pour le développement de votre entreprise.",
    });

    this.meta.updateTag({
      name: "keywords",
      content:
        "inscription PME, création compte entreprise, financement PME Guinée, accompagnement PME, formation entrepreneuriat, BSTP Guinée, banque PME, crédit entreprise, développement entreprise, entrepreneuriat Guinée, formalités création entreprise, accompagnement financier, services bancaires PME, qualification PME",
    });

    this.meta.updateTag({
      name: "author",
      content: "BSTP Guinée - Banque pour le Secteur Privé et les PME",
    });

    // Balises Open Graph pour le partage sur les réseaux sociaux
    this.meta.updateTag({
      property: "og:title",
      content: "Inscription PME - BSTP Guinée",
    });
    this.meta.updateTag({
      property: "og:description",
      content:
        "Rejoignez la communauté des PME dynamiques de Guinée et bénéficiez de services financiers adaptés à vos besoins.",
    });
    this.meta.updateTag({ property: "og:type", content: "website" });

    // Balise pour les appareils mobiles
    this.meta.updateTag({
      name: "viewport",
      content: "width=device-width, initial-scale=1.0",
    });

    // Balise pour la langue
    this.meta.updateTag({ name: "language", content: "fr-FR" });

    this.form = this.fb.group({
      name: this.fb.control(null, [Validators.required]),
      year_of_registration: this.fb.control(null, [Validators.required]),
      email: this.fb.control(null, [Validators.required]),
      phone_number: this.fb.control(null, [Validators.required]),
      type: this.fb.control(null, [Validators.required]),
      region: this.fb.control(null, [Validators.required]),
      prefecture: this.fb.control(null, []),
      commune: this.fb.control(null, []),
      address: this.fb.control(null, [Validators.required]),

      description: this.fb.control(null, [Validators.required]),
      categories: this.fb.array([], [Validators.required]),

      nifp_expiration_date: this.fb.control(null, [Validators.required]),
      quitus_social_expiration_date: this.fb.control(null, [
        Validators.required,
      ]),

      date_of_last_exercise: this.fb.control(null, [Validators.required]),
      effective_of_exercise: this.fb.control(null, [
        Validators.required,
        Validators.min(0),
      ]),
      chiffre_of_exercise: this.fb.control(null, [Validators.required]),
      customer_first_name: this.fb.control(null, [Validators.required]),
      customer_last_name: this.fb.control(null, [Validators.required]),
      customer_phone_number: this.fb.control(null, [Validators.required]),
      customer_email: this.fb.control(null, [Validators.required]),

      leader_full_name: this.fb.control(null, [Validators.required]),
      leader_quality: this.fb.control(null, [Validators.required]),
      reglemented_activity: this.fb.control(null, [Validators.required]),
      actionnariat: this.fb.control(null, [Validators.required]),
      group_joined: this.fb.control(null, [Validators.required]),
      filiale: this.fb.control(null, [Validators.required]),
    });
  }

  onCheckboxChange(e: any) {
    const listSectors: FormArray = this.form.get("categories") as FormArray;

    if (e.target.checked) {
      listSectors.push(this.fb.control(parseInt(e.target.value)));
    } else {
      let i: number = 0;
      listSectors.controls.forEach((item: any) => {
        if (item.value == e.target.value) {
          listSectors.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  ngOnInit(): void {
    this.initForm();
    this.updateStepperItems();
    this.editor = new Editor();

    this.companyTypeService
      .list()
      .subscribe((data: any) => (this.companyTypes = data));

    this.companyService.list().subscribe((data: any) => (this.sectors = data));
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  onSubmit() {
    if (this.form.invalid) {
      for (const control of Object.keys(this.form.controls)) {
        this.form.controls[control].markAsTouched();
      }

      return;
    }

    this.loading = true;

    this.companyService.create(this.form.value).subscribe({
      next: (data: Company) => {
        this.loading = false;
        localStorage.setItem("company_slug", data.slug);
        this.router.navigateByUrl("/registration-success");
      },
      error: (error) => {
        this.loading = false;
        let message = error.error.detail || error.error.non_error_fields[0];
        Swal.fire({
          title: "Erreur!",
          text: message,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#006481",
          color: "#006481",
          iconColor: "#e40e20",
          cancelButtonColor: "#d33",
          confirmButtonText: "Fermer",
          cancelButtonText: "Non, j'annule",
        });
      },
    });
  }

  onRegionsChanged(event) {
    this.prefectures = [];
    this.communes = [];
    const id = parseInt(event.target.value);
    this.prefectureService.value.forEach((value, index) => {
      if (value.region.id == id) {
        this.prefectures.push(value);
      }
    });
  }

  onPrefecturesChanged(event) {
    this.communes = [];
    const id = parseInt(event.target.value);
    this.communeService.value.forEach((value, index) => {
      if (value.prefecture.id == id) {
        this.communes.push(value);
      }
    });
  }

  get filteredCategories() {
    if (
      this.search === null ||
      this.search === undefined ||
      this.search === ""
    ) {
      return this.categoryService.value;
    }

    return this.categoryService.value.filter((request) =>
      request.name.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  // Vérifie si une catégorie est sélectionnée
  isCategorySelected(categoryId: number): boolean {
    return this.form.get("categories").value?.includes(categoryId) || false;
  }

  // Obtient le nom d'une catégorie par son ID
  getCategoryName(categoryId: number): string {
    const category = this.categoryService.value?.find(
      (cat) => cat.id === categoryId
    );
    return category ? category.name : "";
  }

  // Obtient l'icône appropriée pour une catégorie
  getCategoryIcon(categoryName: string): string {
    const name = categoryName.toLowerCase();

    if (name.includes("informatique") || name.includes("technologie"))
      return "icofont-computer";
    if (name.includes("construction") || name.includes("bâtiment"))
      return "icofont-building-alt";
    if (name.includes("santé") || name.includes("médical"))
      return "icofont-doctor";
    if (name.includes("commerce") || name.includes("vente"))
      return "icofont-shopping-cart";
    if (name.includes("restauration") || name.includes("alimentaire"))
      return "icofont-restaurant";
    if (name.includes("transport") || name.includes("logistique"))
      return "icofont-truck";
    if (name.includes("éducation") || name.includes("formation"))
      return "icofont-education";
    if (name.includes("finance") || name.includes("banque"))
      return "icofont-bank";

    return "icofont-tag";
  }

  // Obtient l'icône appropriée pour une forme juridique
  getLegalFormIcon(formName: string): string {
    const name = formName.toLowerCase();

    if (
      name.includes("sarl") ||
      name.includes("société à responsabilité limitée")
    )
      return "icofont-building-alt";
    if (name.includes("sa") || name.includes("société anonyme"))
      return "icofont-factory";
    if (name.includes("eurl") || name.includes("entreprise unipersonnelle"))
      return "icofont-businessman";
    if (name.includes("sas") || name.includes("société par actions simplifiée"))
      return "icofont-briefcase";
    if (name.includes("ei") || name.includes("entreprise individuelle"))
      return "icofont-user";
    if (name.includes("sasu") || name.includes("sas unipersonnelle"))
      return "icofont-briefcase-alt";
    if (name.includes("sci") || name.includes("société civile immobilière"))
      return "icofont-home";

    return "icofont-file-text";
  }

  // Stepper navigation methods
  nextStep() {
    if (this.validateCurrentStep()) {
      if (this.activeIndex < 3) {
        this.activeIndex++;
      }
    }
  }

  prevStep() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  // Validate current step fields
  validateCurrentStep(): boolean {
    let stepFields: string[] = [];

    switch (this.activeIndex) {
      case 0:
        stepFields = [
          "name",
          "year_of_registration",
          "nature_of_activity",
          "type",
          "region",
          "prefecture",
          "commune",
          "address",
          "phone_number",
          "email",
        ];
        break;
      case 1:
        stepFields = ["description", "categories"];
        break;
      case 2:
        stepFields = [
          "date_of_last_exercise",
          "effective_of_exercise",
          "chiffre_of_exercise",
          "customer_phone_number",
          "customer_email",
          "customer_first_name",
          "customer_last_name",
        ];
        break;
      case 3:
        stepFields = [
          "leader_full_name",
          "leader_quality",
          "filiale",
          "group_joined",
          "legal_form",
        ];
        break;
      default:
        return true;
    }

    // Mark fields as touched and check validity
    let isValid = true;
    stepFields.forEach((field) => {
      const control = this.form.get(field);
      if (control) {
        control.markAsTouched();
        if (control.invalid) {
          isValid = false;
        }
      }
    });

    if (!isValid) {
      this.messageService.add({
        severity: "error",
        summary: "Erreur de validation",
        detail: "Veuillez remplir tous les champs obligatoires de cette étape",
      });
    }

    return isValid;
  }

  // Dans create-account.component.ts
  formatCurrency(event: any) {
    // Récupérer la valeur actuelle
    let value = event.target.value.replace(/\s/g, "").replace(/[^0-9]/g, "");

    // Formater avec des espaces comme séparateurs de milliers
    if (value) {
      value = parseInt(value, 10).toLocaleString("fr-FR");
      event.target.value = value;
    }

    // Mettre à jour la valeur du contrôle
    this.form.get("chiffre_of_exercise").setValue(value, { emitEvent: false });
  }

  // Update stepper items to remove unnecessary commands
  updateStepperItems() {
    this.items = [
      {
        label: "INFORMATIONS GÉNÉRALES",
      },
      {
        label: "DESCRIPTION ET ACTIVITÉS",
      },
      {
        label: "INFORMATIONS FINANCIÈRES",
      },
      {
        label: "INFORMATION DU DIRIGEANT",
      },
    ];
  }
}
